module.exports = "/_next/static/images/ScoreMeter4@2x-b0f625cc639b1cfeac0b720c51b7c9b1.png";